import requestReducer from '../requestReducer';
import Invoice from '../../models/Invoice';
import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'


export interface InvoiceDetailState extends PaginatedApiState {
  invoiceLines?: Invoice[]
}

const InvoiceDetail = (state: InvoiceDetailState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<InvoiceDetailState>('INVOICE_DETAIL')(state, action)
  }
}

export default InvoiceDetail